export const SUB_TOPIC_LIST_CONTAINER = 'sub-topic-list';

/** Width from which a sub-topic row lays its name and state out on one line. */
export const SUB_TOPIC_LIST_WIDE_MIN_WIDTH = 560;

export const SUB_TOPIC_LIST_WIDE_QUERY = `@container ${SUB_TOPIC_LIST_CONTAINER} (min-width: ${SUB_TOPIC_LIST_WIDE_MIN_WIDTH}px)`;
